import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaEye, FaEdit } from 'react-icons/fa';
import { FaToggleOn } from "react-icons/fa";
import { FaToggleOff } from "react-icons/fa6";
import { Button, Table, Modal, Input, Space ,Spin} from 'antd';
import './ViewEmployee.css'; 
import { useNavigate } from 'react-router-dom';
import { fetchSiteRequest, updateSiteRequest, deleteSiteRequest } from '../../redux/actions/siteActions.js';
import { fetchProvinceTypesRequest } from '../../redux/actions/provinceActions.js';
import EditSiteForm from "../Forms/Site/EditSite.js";
import ViewSiteDetails from "../Forms/Site/SiteDetails.js";
import ConfirmationModal from '../ConfirmationModel/ConfirmationModel.js';

const SiteTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Redux State
  const { data = [], loading} = useSelector(state => state.site || {});
  const { provinceTypes} = useSelector(state => state.provinceType.provinceType || [] );

  // Local State
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState(data);
  const [selectedSite, setSelectedSite] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [siteToDelete, setSiteToDelete] = useState(null);

  // Fetch data on mount
  useEffect(() => {
    dispatch(fetchSiteRequest());
    dispatch(fetchProvinceTypesRequest());
  }, [dispatch]);

  // Handle Search Query Filtering with Debounce
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchQuery === '') {
        setFilteredData(data);
      } else {
        const filtered = data.filter(site =>
          site.sitename.toLowerCase().includes(searchQuery.toLowerCase()) ||
          site.corporationno.toString().includes(searchQuery)
        );
        setFilteredData(filtered);
      }
    }, 500); // Delay search by 500ms for performance optimization

    return () => clearTimeout(timer); // Clean up on re-renders
  }, [searchQuery, data]);

  // Handle Add Site Button
  const handleAddSite = () => {
    navigate('/siteform');
  };

  // // Handle Delete Site
  // const handleDelete = (site) => {
  //   dispatch(deleteSiteRequest(site));
  // };

  // Handle Edit Site
  const handleEditClick = (site) => {
    setSelectedSite(site);
    setIsEditMode(true);
    setIsModalOpen(true);
  };

  // Handle View Site Details
  const handleViewDetails = (site) => {
    setSelectedSite(site);
    setIsEditMode(false);
    setIsModalOpen(true);
  };

  // Handle Save/Update Site
  const handleEditSite = (updatedSite) => {
    dispatch(updateSiteRequest(updatedSite));
    setIsModalOpen(false);
  };

      // Open confirmation modal
      const openDeleteModal = (site) => {
        setSiteToDelete(site);
        setIsConfirmModalVisible(true);
      };
    
      // Handle confirm delete
      const handleConfirmDelete = () => {
        if (siteToDelete) {
          dispatch(deleteSiteRequest(siteToDelete));
          setIsConfirmModalVisible(false);
          setSiteToDelete(null);
        }
      };
    
      // Handle cancel delete
      const handleCancelDelete = () => {
        setIsConfirmModalVisible(false);
        setSiteToDelete(null);
      };

  // Close Modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedSite(null);
    setIsEditMode(false);
  };

  // Table Columns
  const columns = [
    {
      title: 'Sr. No.',
      render: (_, __, index) => index + 1, // Render serial number starting from 1
    },
  
    {
      title: 'Site Name',
      dataIndex: 'sitename',
      sorter: (a, b) => a.sitename.localeCompare(b.sitename),
      render: (text, record) => (
        <div>
          <div>{record.sitename}</div>
          <div>{` ${record.corporationno}`}</div>
        </div>
      ),
       // sorter: (a, b) => a.sitename.toLowerCase().localeCompare(b.sitename.toLowerCase()),
    // defaultSortOrder: 'ascend', // Uncomment to set the default sorting order (ascending)
    },
    {
      title: 'Address',
      render: (_, record) => ( 
        <div className="address-content">
        {`${record.address}, ${record.city}, ${record.province}, ${record.postalcode}`}
      </div>
    ),
    width: 200,

    },
    {
      title: 'Phone',
      dataIndex: 'phone',
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },
    {
      title: 'Website',
      dataIndex: 'website',
    },
    {
      title: 'Status',
      render: (_, record) => {
        const status = record.activated === 1 ? 'Active' : 'Inactive';
        const statusColor = record.activated === 1 ? 'lightgreen' : '#f3c6c7';
        return (
          <Button
            style={{
              backgroundColor: statusColor,
              color: 'black',
              alignItems: 'center',
              margin: '4px',
              width: '100%',
              borderRadius: '12px', 
              padding: '5px 15px',  
              border: 'none',
              display: 'block' 
            }}
            disabled
          >
            {status}
          </Button>
        );
      },
    },
    
    {
      title: 'Actions',
      render: (_, record) => (
        <Space size="middle">
          <Button icon={<FaEye />} onClick={() => handleViewDetails(record)} />
          <Button icon={<FaEdit />} onClick={() => handleEditClick(record)} />
          <Button
           icon={
            record.activated ? (
              <FaToggleOn style={{ color: "green" }} />
            ) : (
              <FaToggleOff  style={{ color: "red" }} />
            )
          }
            onClick={() => openDeleteModal(record)}
          
          />
        </Space>
      ),
    },
  ];


  return (
    <Spin spinning={loading} tip="Loading sites...">
    <div className="employee-table"> {/* Reuse the employee-table class */}
      {/* Add Site Button */}


      <div className="actions-container">

  <div className="view-employee-text">
    View Sites 
  </div>

  <Button 
    type="primary" 
    className="addbutton" 
    onClick={handleAddSite}
    
  >
    + Add Site
  </Button>
  </div>

      

      {/* Search Bar */}
      <div className="search-container">
        <Input
          type="text"
          placeholder="Search by Site Name or Corporation Number..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input"
        />
      </div>

      {/* Site Table */}
      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey="corporationno"
        pagination={false}
        scroll={{ x: 'max-content' }}
        tableLayout="auto"
      />

      {/* Modal for View/Edit Site */}
      {isModalOpen && selectedSite && (
        <Modal
          title={isEditMode ? 'Edit Site Details' : 'Site Details'}
          open={isModalOpen}
          onCancel={closeModal}
          footer={null}
          centered
          width={isEditMode ? 800 : 520}
        >
          {isEditMode ? (
            <EditSiteForm
              site={selectedSite}
              onSubmit={handleEditSite}
              closeModal={closeModal}
              provinces={provinceTypes}
            />
          ) : (
            <ViewSiteDetails
              site={selectedSite}
              closeModal={closeModal}
            />
          )}
        </Modal>

      )}

            
<ConfirmationModal
        visible={isConfirmModalVisible}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        deletetext={
          siteToDelete?.activated
          ? "Inactive"    
          : "Active"
        }
        message={
          siteToDelete?.activated
            ? "Are you sure you want to Inactive the site?"    
            : "Are you sure you want to Active the site?"
        }
      />

    </div>
    </Spin>
  );
};

export default SiteTable;

